import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ButtonBanner } from 'src/app/interfaces/banner/button-banner';

@Component({
  selector: 'app-button-banner',
  templateUrl: './button-banner.component.html',
  styleUrls: ['./button-banner.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ButtonBannerComponent implements OnInit {
  constructor() {}

  @Input() buttonBanner!: ButtonBanner;

  @Output() bannerButtonClick: EventEmitter<{ navigate: (string | number)[] }> =
    new EventEmitter<{ navigate: (string | number)[] }>();

  ngOnInit(): void {}
}
